function PlpNativeSkeletonList() {
  return (
    <div className="w-full">
      {[...Array(4)].map(() => (
        <div role="status" className="w-full animate-pulse rounded border-b py-6 last:border-b-0">
          <div className="flex w-full items-center justify-between">
            <div className="w-full">
              <div className="mb-2 h-6 w-full bg-skeleton" />
              <div className="h-4 w-2/3 bg-skeleton" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default PlpNativeSkeletonList
